import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=bf73f0f2&scoped=true"
import script from "./setting.vue?vue&type=script&route=%2Ffin%2Fsetting&lang=js"
export * from "./setting.vue?vue&type=script&route=%2Ffin%2Fsetting&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf73f0f2",
  null
  
)

export default component.exports